// extracted by mini-css-extract-plugin
export default {"scroll":"Albums_scroll__-Qas0","list":"Albums_list__nRcbk","listItem":"Albums_listItem__lKAsv","image":"Albums_image__lBdkh","title":"Albums_title__Q9D7R"};